'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/* eslint-disable react/no-unused-prop-types */
const Page = ({ children }) => React__default["default"].createElement("div", null, children);
Page.displayName = 'Page';
Page.defaultProps = { application: undefined, permission: undefined };

exports["default"] = Page;
